import React from "react";
import { useTranslation } from "react-i18next";
import { ProgressBar } from "react-bootstrap";
import imgPlanOK from "assets/plan-ok.png";
import { formatRelativeDateTime } from "utils/datetime";
import moment from "moment";
import SubmitButton from "components/SubmitButton";
import ScheduleParser from "utils/parserIntelligentResponse";

const PlanIntelligentModal = ({
	roundedCobertura,
	handleClose,
	handleSubmit,
	planIntelligentStatus,
}) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = React.useState(false);
	const getVariant = (roundedCobertura) => {
		if (roundedCobertura >= 90) {
			return "success";
		} else if (roundedCobertura >= 70) {
			return "warning";
		} else {
			return "danger";
		}
	};

	const handleSave = async (e) => {
		setIsLoading(true);
		handleSubmit(e);
	};

	const data = ScheduleParser.parseDetailed(planIntelligentStatus);

	return (
		<form onSubmit={handleSave}>
			<div className="modal-body text-center">
				<div>
					<img
						className="img-plan"
						src={imgPlanOK}
						alt="Plan OK"
						style={{ width: "220px" }}
					/>

					<div>
						<h4>Planificación realizada correctamente</h4>
						<div className="mb20">
							<div
								className="cobertura"
								style={{
									maxWidth: "250px",
									margin: "0 auto 25px auto",
								}}
							>
								<p style={{ marginBottom: "5px" }}>
									Cobertura obtenida: <strong>{roundedCobertura} %</strong>
								</p>
								<ProgressBar
									striped
									now={roundedCobertura}
									label={`${roundedCobertura}%`}
									variant={getVariant(roundedCobertura)}
									style={{ marginBottom: 0 }}
								/>
							</div>
							<span className="text-info">
								{`Lanzado por ${
									planIntelligentStatus.employee_full_name
								} ${formatRelativeDateTime(planIntelligentStatus.start)}`}
							</span>

							<p style={{ marginBottom: "5px" }}>
								Fechas:{" "}
								<strong>
									{moment(data.start).format("DD/MM/YYYY")} -{" "}
									{moment(data.end).format("DD/MM/YYYY")}
								</strong>
							</p>
						</div>

						<div className="modal-footer">
							<button
								type="button"
								onClick={handleClose}
								className="btn btn-outline-primary"
							>
								{t('common.discard')}
							</button>
							<SubmitButton
								type="submit"
								isLoading={isLoading}
								text={t('common.save')}
								loadingText={t('common.saving')}
							/>
						</div>
					</div>
				</div>
			</div>
		</form>
	);
};

export default PlanIntelligentModal;
